var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useLayoutEffect, useRef } from 'react';
import { useBreakpointValue, Box } from '@noom/wax-component-library';
import InputText from '../../../core/components/InputText';
import RichTextEditor from './components/Editor';
import { markdownToSlate, slateToMarkdown } from './markdownParser';
import { stripMentionTags } from './plugins/mentionPlugin/utils';
const InputTextEditor = InputText;
function SimpleTextEditor(_a) {
    var { append, prepend } = _a, props = __rest(_a, ["append", "prepend"]);
    return (React.createElement(Box, null,
        prepend,
        React.createElement(InputTextEditor, Object.assign({}, props)),
        append));
}
export function AmityAdapterEditor(_a) {
    var { id, disabled, invalid, initialMentionees, value = '', onChange, rows = 3 } = _a, rest = __rest(_a, ["id", "disabled", "invalid", "initialMentionees", "value", "onChange", "rows"]);
    const editorRef = useRef(null);
    useLayoutEffect(() => {
        var _a;
        if (value === '') {
            (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        }
    }, [value, editorRef]);
    const handleChange = (data) => {
        const newMarkdown = slateToMarkdown(data.value);
        onChange({
            text: newMarkdown.text,
            plainText: stripMentionTags(newMarkdown.text),
            mentions: newMarkdown.mentions,
        });
    };
    // Quick fix to deal with the broken editor on mobile
    const useSimpleEditor = useBreakpointValue({ base: true, lg: false });
    if (useSimpleEditor) {
        return (React.createElement(SimpleTextEditor, Object.assign({ id: id, rows: rows, multiline: true, onChange: onChange, disabled: disabled, invalid: invalid, value: value }, rest)));
    }
    return (React.createElement(RichTextEditor, Object.assign({ id: id, rows: rows, ref: editorRef, onChange: (data) => handleChange(data), isDisabled: disabled, isInvalid: invalid, initialValue: markdownToSlate(value, initialMentionees), isToolbarVisible: true }, rest)));
}
export default AmityAdapterEditor;
//# sourceMappingURL=AmityAdapterEditor.js.map